import { render, staticRenderFns } from "./uploadIndustry.vue?vue&type=template&id=67ce795e&"
import script from "./uploadIndustry.vue?vue&type=script&lang=js&"
export * from "./uploadIndustry.vue?vue&type=script&lang=js&"
import style0 from "./uploadIndustry.vue?vue&type=style&index=0&id=67ce795e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports